import { useParams } from "react-router-dom";
import { useCurrentJointBillServicePeriodId } from "@hooks/useCurrentJointBillServicePeriodId";
import { useJointBillServicePeriodListQuery } from "@services/jointBillServices/queries";

export const useJointBillServicePeriod = (): {
  periodId: number | undefined;
  isLoading: boolean;
} => {
  const { isLoading } = useJointBillServicePeriodListQuery();
  const currentPeriodId = useCurrentJointBillServicePeriodId();
  const { periodId: periodIdParam } = useParams<{ periodId: string }>();
  const parsedPeriodIdParam = periodIdParam
    ? parseInt(periodIdParam)
    : undefined;
  const periodId = parsedPeriodIdParam ?? currentPeriodId;

  return {
    periodId,
    isLoading,
  };
};
